import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  textColor: "#202020",
  lightTextColor: "#909090",
  now: {
    status: {
      ok: '#f7cd47',
      bad: '#ea3323',
      good: '#85d076',
      warn: '#f2935c',
    },
  },
  skyw: {
    grayTextColor: '#e1d7d5',
    mainColor1: '#4a93e7',
    mainColor2: '#7fa8c3',
    warnColor: '#f7cd47',
    badColor: '#cf4a40',
  },
};
